import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  connect() {
    reactor(this)
    this.timer = setInterval(this.tick.bind(this), 1000)
    this.tick()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  morph() {
    this.tick()
  }

  tick() {
    const timestamp = parseInt(this.element.dataset.timeAgoInWordsTimestampValue, 10)
    const compact = this.element.dataset.timeAgoInWordsCompactValue === "true"
    const seconds = Math.floor(Date.now() / 1000) - timestamp
    const text = compact ? this.compactDistance(seconds) : this.distanceInWords(seconds)
    if (this.element.textContent !== text) this.element.textContent = text
  }

  compactDistance(seconds) {
    if (seconds < 60) return "<1m"
    if (seconds < 3600) return `${Math.round(seconds / 60)}m`
    if (seconds < 86400) return `${Math.round(seconds / 3600)}h`
    if (seconds < 2592000) return `${Math.round(seconds / 86400)}d`
    if (seconds < 31536000) return `${Math.round(seconds / 2592000)}mo`
    return `${Math.round(seconds / 31536000)}y`
  }

  distanceInWords(seconds) {
    if (seconds < 30) return "<1 minute"
    if (seconds < 90) return "1 minute"
    if (seconds < 2700) return `${Math.round(seconds / 60)} minutes`
    if (seconds < 5400) return "1 hour"
    if (seconds < 86400) return `${Math.round(seconds / 3600)} hours`
    if (seconds < 172800) return "1 day"
    if (seconds < 2592000) return `${Math.round(seconds / 86400)} days`
    if (seconds < 5184000) return "1 month"
    if (seconds < 31536000) return `${Math.round(seconds / 2592000)} months`
    return `${Math.round(seconds / 31536000)} years`
  }
}
